import { render, staticRenderFns } from "./dataReview.vue?vue&type=template&id=71eb87e6&scoped=true"
import script from "./dataReview.vue?vue&type=script&lang=ts"
export * from "./dataReview.vue?vue&type=script&lang=ts"
import style0 from "./dataReview.vue?vue&type=style&index=0&id=71eb87e6&prod&lang=scss&scoped=true"
import style1 from "./dataReview.vue?vue&type=style&index=1&id=71eb87e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eb87e6",
  null
  
)

export default component.exports